'use client'

import React from 'react'

import FormModal from '~/layouts/shared/form-modal'
import { IFormModal } from '~/types/form'

interface Props {
  isOpened: boolean
  onClose: () => void
  formModal: IFormModal
}

const ContactModalsContent: React.FC<Props> = ({
  isOpened,
  onClose,
  formModal,
}) => {
  return (
    <div className="contact-modals">
      <FormModal isActive={isOpened} modalData={formModal} onClose={onClose} />
    </div>
  )
}

export default ContactModalsContent
